import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {NotificationBell} from '../../../../app/modules/notifications/components/NotificationBell'
import {WhatsNewMenu} from '../../../../app/modules/whats-new/WhatsNewMenu'
import {WalletBalanceChip} from '../../../../app/modules/online-payment/wallet/WalletBalanceChip'
import {UserAvatar} from '../../../../app/modules/profile/components/UserAvatar'
import {BusinessChip} from '../../../../app/modules/apps/shared/business-switcher/BusinessChip'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-40px h-40px'
const userAvatarClass = 'symbol-40px'
const btnIconClass = 'fs-1'

const Navbar = () => {
  const {currentUser} = useAuth()
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div> */}
      {/*
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
         <HeaderNotificationsMenu /> 
      </div>
      */}
      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      {/* An administrator picks the business on the pages that follow it (their own picker), not here. */}

      {/* The business this tab works in; a click (or Ctrl+K) chooses another for this tab only. */}
      <BusinessChip itemClassName={itemClass} />

      {/* «قوانین و مقررات» lives in «حساب کاربری › قوانین و مقررات» (and the acceptance window). */}

      {/* The selected business's wallet balance, beside «امکانات تازه». */}
      <WalletBalanceChip itemClassName={itemClass} />

      {/* «امکانات تازه»: the list of what is new for this user, each opening its introduction. */}
      <WhatsNewMenu itemClassName={itemClass} buttonClassName={btnClass} />

      <div className={clsx('app-navbar-item', itemClass)}>
        <NotificationBell buttonClassName={btnClass} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <button
          type='button'
          className={clsx('cursor-pointer symbol border-0 bg-transparent p-0', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          title='حساب کاربری'
          aria-label='حساب کاربری'
        >
          {currentUser?.support ? (
            <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='حالت پشتیبانی' />
          ) : (
            <UserAvatar user={currentUser} size={38} />
          )}
        </button>
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Navbar}
